import React, { useEffect, useRef } from 'react';
import { StyleSheet, Animated, TouchableOpacity } from 'react-native';

import { Box } from '@components/Restyle/index';
import Text from '@components/Restyle/Text';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

type ConvertedToTaskProps = {
  duration: number;
  onPress?: () => void;
  message?: string;
};

export const ConvertedToTaskToast: React.FC<ConvertedToTaskProps> = ({
  duration,
  onPress,
  message,
}) => {
  const progressAnim = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    Animated.timing(progressAnim, {
      toValue: 1,
      duration: duration,
      useNativeDriver: false,
    }).start();
  }, [progressAnim, duration]);

  const handlePress = () => {
    onPress?.();
  };

  return (
    <TouchableOpacity
      disabled={!onPress}
      onPress={handlePress}
      accessibilityLabel={message}>
      <Box
        height={80}
        width={351}
        backgroundColor='black'
        style={{
          overflow: 'hidden',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'flex-start',
          position: 'relative',
        }}>
        <Box
          mx='l'
          style={{ paddingVertical: 22 }}
          height={76}
          width={303}
          flexDirection='row'
          alignItems='center'>
          <Icon name='Check' variant='l' color='white' />
          <Text flex={1} ml='xs' mr='m' variant='heading2' color='white'>
            {message}
          </Text>
          {!!onPress && <Icon name='ArrowRight' variant='l' color='white' />}
        </Box>

        <Animated.View
          style={[
            styles.progressBar,
            {
              width: progressAnim.interpolate({
                inputRange: [0, 1],
                outputRange: ['0%', '100%'],
              }),
            },
          ]}
        />
      </Box>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  progressBar: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: 4,
    backgroundColor: theme.colors.greenBrand,
  },
});
